import { atom, useAtom } from 'jotai';
import { useAgreementsByIdQuery } from '@/feature/agreement/query';

const acknowledgementsCheckedAtom = atom(false);
const useAcknowledgementsChecked = () => useAtom(acknowledgementsCheckedAtom);

export const useAcknowledgements = (documentIds: string[]) => {
  const { agreements, isLoading } = useAgreementsByIdQuery(documentIds);
  const acknowledgements = agreements.map((a) => a.acknowledgements).flat();
  const [acknowledgementsChecked, setAllChecked] = useAcknowledgementsChecked();
  const allChecked =
    acknowledgementsChecked || (!isLoading && acknowledgements.length === 0);

  return { acknowledgements, allChecked, setAllChecked };
};
